import { useEffect, useRef, useState } from "react";
import { Select, Col, Form, Input, Row, DatePicker, Table, Button, notification, message, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { dropdownService, ledgerService, PdfService } from "../../../../services";
import { ROLES } from "../../../../constants";
import { BsFillSendFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { BiSearchAlt } from "react-icons/bi";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { changeDocumentTitle } from "../../../../utils/title";

const status = [{ id: 1, name: "All" }, { id: 2, name: "Opened" }, { id: 3, name: "Closed" }];

function Ledger() {

  const contentRef = useRef();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const [loading, setLoading] = useState(false)
  const [emailloading, setEmailLoading] = useState(false);
  const [pdfload, setPDFLoad] = useState(false)
  const [ledger, setLedger] = useState([]);
  const [filteredLedger, setFilteredLedger] = useState([])
  const [payload, setPayload] = useState(null)
  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([])
  const [customerId, setCustomerId] = useState(role === ROLES.CUSTOMER ? loggedInUser.id : 0);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (index) => index + 1,
    },
    {
      title: "STATUS",
      dataIndex: "STATUS",
      key: "STATUS",
    },
    {
      title: "INVOICE DATE",
      dataIndex: "INVOICE DATE",
      key: "INVOICE DATE",
    },
    {
      title: "INVOICE NUMBER",
      dataIndex: "INVOICE NUMBER",
      key: "INVOICE NUMBER",
      width: 10,
      render: (text) => (
        <a
          href={`/invoice/view/${text}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline hover:text-blue-800"
        >
          {text}
        </a>
      )
    },
    {
      title: "RECEIPT NUMBER",
      dataIndex: "RECEIPT NUMBER",
      key: "RECEIPT NUMBER",
    },
    {
      title: "CREDIT NUMBER",
      dataIndex: "CREDIT NUMBER",
      key: "CREDIT NUMBER",
    },
    {
      title: "DESCRIPTION",
      dataIndex: "DESCRIPTION",
      key: "DESCRIPTION",
    },
    {
      title: "INVOICE AMOUNT",
      dataIndex: "INVOICE AMOUNT",
      key: "INVOICE AMOUNT",
      width: 10
    },
    {
      title: "CREDIT AMOUNT",
      dataIndex: "CREDIT AMOUNT",
      key: "CREDIT_AMOUNT",
      width: 10
    },
    {
      title: "COLLECTED AMOUNT",
      dataIndex: "COLLECTED AMOUNT",
      key: "COLLECTED AMOUNT",
      width: 10
    },
    {
      title: "BALANCE",
      dataIndex: "BALANCE",
      key: "BALANCE",
      width: 10
    },
  ];

  const columns2 = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
    },
    {
      title: "STATUS",
      dataIndex: "STATUS",
      key: "STATUS",
    },
    {
      title: "ADVANCE COLLECTION #",
      dataIndex: "ADVANCE_COLLECTION_RECEIPT",
      key: "ADVANCE_COLLECTION_RECEIPT",
    },
    {
      title: "ADVANCE ADJUSTMENT DOC #",
      dataIndex: "ADVANCE_ADJUSTMENT_RECEIPT",
      key: "ADVANCE_ADJUSTMENT_RECEIPT",
    },
    {
      title: "ADVANCE RECEIVED",
      dataIndex: "ADVANCE RECEIVED",
      key: "ADVANCE RECEIVED",
    },
    {
      title: "ADVANCE ADJUSTED",
      dataIndex: "ADVANCE ADJUSTED",
      key: "ADVANCE ADJUSTED",
    },
    {
      title: "BALANCE",
      dataIndex: "ADVANCE BALANCE",
      key: "ADVANCE BALANCE",
    },
  ]

  const handleFilter = async (values) => {
    const payload = {
      ...values,
      user_id: values.user,
      from_date: values.from_date ? values.from_date.format("YYYY-MM-DD") : null,
      to_date: values.to_date ? values.to_date.format("YYYY-MM-DD") : null,
      status: values.status === "All" ? null : values.status,
    };

    const filteredData = Object.fromEntries(Object.entries(payload).filter(([_, value]) => value != null));
    delete filteredData.user;
    setPayload(filteredData)
    initialize(filteredData);
  };

  const handleSearch = async ({ invoice_number = null, container_number = null }) => {
    const filteredData = ledger.data.filter((item) => {
      if (invoice_number && container_number) {
        return (item['INVOICE NUMBER'] === invoice_number ||
          item['DESCRIPTION'].toLowerCase().includes(container_number.toLowerCase()))
      }
      if (invoice_number) {
        return item['INVOICE NUMBER'] === invoice_number;
      }
      if (container_number) {
        return item['DESCRIPTION'].toLowerCase().includes(container_number.toLowerCase())
      }
      if (!invoice_number && !container_number) {
        return item
      }
    })
    setFilteredLedger(filteredData);
  }

  const initialize = async (data = null, search = null) => {
    setLoading(true)
    const { success, data: LedgerData } = await ledgerService.fetch(data, search);
    setLoading(false)
    if (success) {
      setLedger(LedgerData);
      setFilteredLedger(LedgerData.data)
      const invoiceData = LedgerData.data.map((item) => item['INVOICE NUMBER']);
      setInvoices(invoiceData)
    }
  };

  const getCustomers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };

  const sendMail = async () => {
    setEmailLoading(true)
    const res = await ledgerService.sendMail(payload)
    setEmailLoading(false)
    if (res.success) {
      notification.success({
        message: "Email Sent Successfully!",
        placement: 'topRight'
      })
    }
  }

  const handlePDFDownload = async () => {
    setPDFLoad(true);

    const { user_id } = payload;
    const username = customers.find((c) => c.id === user_id)?.name;

    const updatedPayload = {
      ...payload,
      customer: payload.user_id
    };

    delete updatedPayload.user_id;

    const response = await PdfService.download(username, updatedPayload);
    if (!response.success) {
      notification.error({ message: "Error Downloading PDF!" })
    }

    setPDFLoad(false);
  };

  useEffect(() => {
    changeDocumentTitle("Ledger");
    if (role !== ROLES.CUSTOMER) {
      getCustomers();
    }
  }, []);

  // const components = {
  //   header: {
  //     cell: (props) => (
  //       <th {...props} style={{ backgroundColor: "#0A3C67", color: "white", textAlign: "center", padding: "10px" }} />
  //     ),
  //   },
  // };

  return (
    <div
      style={{
        padding: "0 14px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Form layout="vertical" form={form} onFinish={handleFilter} initialValues={{ status: "All" }}>
        <Row gutter={16} className="mt-8">
          <Col span={4}>
            <Form.Item label="From date" name="from_date">
              <DatePicker placeholder="Select Date" style={{ width: "100%", height: "45px" }} />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item label="To date" name="to_date">
              <DatePicker placeholder="Select Date" style={{ width: "100%", height: "45px" }} />
            </Form.Item>
          </Col>

          {role !== ROLES.CUSTOMER && (
            <Col span={5}>
              <Form.Item label="Customers" name="user" rules={[{ required: true, message: "Please select a customer!" }]}>
                <Select
                  placeholder="Select Customer"
                  showSearch
                  optionFilterProp="children"
                  onChange={(e) => setCustomerId(e)}
                  style={{ width: "100%", height: "45px" }}
                >
                  {customers?.map((cust) => (
                    <Select.Option key={cust.id} value={cust.id}>
                      {cust.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          {customerId > 0 &&
            <>
              <Col span={5}>
                <Form.Item label="Status" name="status" rules={[{ required: true, message: "Please input!" }]}>

                  <Select  style={{ width: "100%", height: "45px" }}>
                    {status?.map((s) => (
                      <Select.Option key={s.id} value={s.name}>
                        {s.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </>
          }

          <Col span={5} className="mt-7 flex gap-3">
            <Button
              className="h-11"
              type="default"
              size="middle"
              htmlType="submit"
              icon={<BiSearchAlt style={{ fontSize: 20 }} />}
            >
              Search
              {/* <SearchOutlined style={{ fontSize: "15px" }} /> */}
            </Button>
            {filteredLedger.length === 0 ? null :
              <Button className="h-11"
                type="default"
                size="middle"
                onClick={sendMail}
                loading={emailloading}
                icon={<BsFillSendFill style={{ fontSize: "15px" }} />}>
                Send
              </Button>
            }
          </Col>
        </Row>
      </Form>

      {filteredLedger.length === 0 ? null :
        <div className='flex justify-end' >
          <Button onClick={() => {
            if (ledger?.data?.length > 0) {
              handlePDFDownload()
            } else {
              return message.error("Data not available")
            }
          }} loading={pdfload} className='bg-[#EEF2F6]'
            icon={<BsFileEarmarkPdf style={{ fontSize: "20px" }} />}
          >
            PDF
          </Button>

        </div>
      }
      <div ref={contentRef}>
        <Row
          gutter={0}
          style={{
            marginTop: 20,
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #E8E8E9",
            display: "flex",
            alignItems: "center",
          }}
        >
          {
            ledger?.data?.length > 0 &&
            <Form layout="vertical" form={form2} onFinish={handleSearch} style={{ width: "100%" }}>
              <Row gutter={16} style={{ width: '100%' }}>

                <Col span={7}>
                  <Form.Item label="Invoice No." name="invoice_number">
                    <Select placeholder="Select Invoice Number" allowClear showSearch optionFilterProp="children" style={{ width: "100%", height: "45px" }}>
                      {invoices?.map((item) => {
                        return (
                          <Select.Option key={item} value={item}>
                            {item}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={7}>
                  <Form.Item label="Container No." name="container_number">
                    <Input placeholder="container Number" style={{ width: "100%", height: "45px" }} />
                  </Form.Item>
                </Col>
                <Col span={10} style={{ textAlign: "left" }}>
                  <Form.Item label=" ">
                    <Button
                      className="h-11"
                      type="default"
                      size="middle"
                      htmlType="submit"
                      icon={<BiSearchAlt style={{ fontSize: 20 }} />}>
                      Search
                    </Button>
                  </Form.Item>
                </Col>

              </Row>
            </Form>
          }
          {/* <Col span={4}><img src="/images/ctrade-logo.png" className="h-20 w-40" /></Col> */}
          <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <Typography.Title level={2} style={{ textDecoration: 'underline' }}>Statement Of Account</Typography.Title>
          </Col>
        </Row>

        <Col span={24}>
          <div id="printable-table">
            <Table
              columns={columns}
              bordered
              // components={components}
              loading={loading}
              pagination={false}
              scroll={{ x: "max-content" }}
              dataSource={filteredLedger}
              rowKey={(record, index) => index}
              locale={{
                emptyText: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    No data available in table
                  </div>
                ),
              }}
              style={{ marginTop: "5px" }}
              summary={() => (
                <>
                  <Table.Summary.Row className="font-bold  ">
                    <Table.Summary.Cell
                      colSpan={columns?.length - 5}
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell>TOTAL:</Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1}>${ledger.receivables}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1}>${ledger.creditTotal}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1}>${ledger.collectedTotal}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1}>${ledger.balance}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                  {ledger?.advanceData?.length === 0 && <Table.Summary.Row className="text-center font-bold">
                    <Table.Summary.Cell colSpan={10}>NET BALANCE:</Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1} className="text-left">${ledger.netAmount}</Table.Summary.Cell>
                  </Table.Summary.Row>}
                </>
              )}
            />
          </div>
        </Col>
        {ledger?.advanceData?.length > 0 &&
          <>
            <Col span={24} style={{ backgroundColor: "#377FBE", color: "white", padding: 10, fontSize: 15, marginTop: 15, textAlign: "center" }}>ADVANCE BALANCE</Col>
            <Col span={24}>
              <Table
                columns={columns2}
                bordered
                // components={components}
                pagination={false}
                rowKey='#'
                dataSource={ledger.advanceData}
                summary={() => (
                  <Table.Summary.Row className="text-center font-bold text-white bg-[#A82C38]">
                    <Table.Summary.Cell colSpan={6}>NET BALANCE:</Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={1} className="text-left">${ledger.netAmount}</Table.Summary.Cell>
                  </Table.Summary.Row>
                )}
              />
            </Col>
          </>
        }
      </div>
    </div >
  );
}

export default Ledger;
